/**
 * Utility functions for proper Bugsnag error handling
 */

/**
 * Creates an Error object from a string message if needed
 * @param {string|Error} errorOrMessage - The error object or message string
 * @returns {Error} - An Error object
 */
export const createBugsnagError = errorOrMessage => {
  if (errorOrMessage instanceof Error) {
    return errorOrMessage
  }
  return new Error(errorOrMessage)
}
